import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import { useTranslation } from "react-i18next";
import AutoForm from "../form/functional/AutoForm";
import getSchema from "../../lib/api/getSchema";
import {debounce, cloneDeep} from "lodash";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import CorporationManageCreateButton from "../input/CorporationManageCreateButton";
import CorporationManageUpdateButton from "../input/CorporationManageUpdateButton";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import BasicCrudScreenHeaderLayout from "../screenTypes/layout/BasicCrudScreenHeaderLayout";
import BasicCrudActionsLayout from "../screenTypes/layout/BasicCrudActionsLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";
import CoprationDeleteButton from "../input/CoprationDeleteButton";
import AutoFormViewLayout from "../form/layout/AutoFormViewLayout";

const id = "CorporationManage";
const table = "MomSysUdtCompany";
const view = "MomSysVwOwnCompany";

function tableModifySchema(schema, type = 'create')  {
    
    for(const column of schema.columns) {
                
        switch(column.name) {

            case "companyCode" : 
                column.displayName = "corporationCode";
                if(type === 'create') {
                    delete column.key
                    column.readonly = false;
                }
                break;

            case "companyName" :

                column.displayName = "corporationName";
                break;
            
            case "typeOwn":
                column.defaultValue = "1";
                column.hideInForm = true;
                break;

            case "companyAlias": case "img": case "img2":
            case "ceoPhone" : case "email":
            case "digitalTaxInvoiceEmail" : case "companyRegNo":
            case "corporationNo" : case "bankCode":
            case "homePage" : case "description":
            case "typeBuyer":  case "typeSupplyer": 
            case "typeOutSourcing" : case "ceoName" : case "bankAccount":
                column.hideInForm = true;

            break;

            case "companyFullName" :
                column.formGroup = 0;
                column.formOrder = 15;
                column.displayName = "corporationFullName";
                column.hideInForm = false;
            break;

            case "ceoResidentNumber" :
                column.formGroup = 0;
                column.formOrder = 20;
                column.hideInForm = false;
            break;
            case "foundingDate" :
                column.formGroup = 0;
                column.formOrder = 300;
                column.formItemType = "date"
                column.hideInForm = false;
            break;
            case "companyEnglishName" :
                column.formGroup = 0;
                column.formOrder = 400;
                column.hideInForm = false;
            break;
            case "businessType" :
                column.formGroup = 0;
                column.formOrder = 500;
                column.hideInForm = false;
            break;
            case "sector" :
                column.formGroup = 0;
                column.formOrder = 600;
                column.hideInForm = false;
            break;
            case "zipcode" :
                column.formGroup = 1;
                column.formOrder = 200;
                column.formItemType = 'zipcode';
                column.hideInForm = false;
            break;
            case "englishAddress" :
                column.formGroup = 1;
                column.formOrder = 250;
                column.hideInForm = false;
                column.disabled = true;
            break;
            case "address" :
                column.formGroup = 1;
                column.formOrder = 300;
                column.hideInForm = false;
                column.disabled = true;
            break;
            case "englishAddressDetail1" :
                column.formGroup = 1;
                column.formOrder = 350;
                column.hideInForm = false;
            break;
            case "addressDetail" :
                column.formGroup = 1;
                column.formOrder = 400;
                column.hideInForm = false;
            break;
            case "englishAddressDetail2" :
                column.formGroup = 1;
                column.formOrder = 410;
                column.hideInForm = false;
            break;
            case "countryCode" :
                column.formGroup = 1;
                column.formOrder = 450;
                column.hideInForm = false;
                column.formItemType = "commoncode";
                column.commonCodeInfo = {
                    mstCodeId : "B006",
                    tableName: "CommonCodeSlave",
                    nameColumn: ["slaveCodeId", "slaveCodeName"],
                    valueColumn: "slaveCodeId",
                    useEmptyValue: false,
                    emptyName: "term.none",
                    sortByName: true,
                    overrideLabel : "columnName.countryCode"
                }
            break;
            case "phoneNumber1" :
                column.formGroup = 1;
                column.formOrder = 500;
                column.hideInForm = false;
            break;
            case "phoneNumber2" :
                column.formGroup = 1;
                column.formOrder = 550;
                column.hideInForm = false;
            break;
            case "fax" :
                column.formGroup = 1;
                column.formOrder = 560;
                column.hideInForm = false;
            break;
            case "managementGeneral" :
                column.formGroup = 1;
                column.formOrder = 600;
                column.hideInForm = false;
            break;
            case "session" :
                column.formGroup = 2;
                column.formOrder = 100;
                column.hideInForm = false;
            break;
            case "sessionStartDate" :
                column.formGroup = 2;
                column.formOrder = 200;
                column.formItemType = "date"
                column.hideInForm = false;
            break;
            case "sessionEndDate" :
                column.formGroup = 2;
                column.formOrder = 300;
                column.formItemType = "date"
                column.hideInForm = false;
            break;
            default: 
            column.disabled = true;
            column.required = false;
            break;
        }
    }

}
function readOnlyModifySchema(schema)  {

    schema.columns.push({name : "countryCodeName"});
    
    for(const column of schema.columns) {

        column.disabled = true;
        column.hideInForm = true;
        switch(column.name) {

            case "ceoResidentNumber" :
                column.formGroup = 0;
                column.formOrder = 20;
                column.hideInForm = false;
            break;
            case "foundingDate" :
                column.formGroup = 0;
                column.formOrder = 300;
                column.formItemType = "date"
                column.hideInForm = false;

            break;
            case "companyEnglishName" :
                column.formGroup = 0;
                column.formOrder = 400;
                column.hideInForm = false;

            break;
            case "businessType" :
                column.formGroup = 0;
                column.formOrder = 500;
                column.hideInForm = false;

            break;
            case "sector" :
                column.formGroup = 0;
                column.formOrder = 600;
                column.hideInForm = false;

            break;
            case "zipcode" :
                column.formGroup = 1;
                column.formOrder = 200;
                column.formItemType = 'zipcode';
                column.disabled = true;
                column.hideInForm = false;

            break;
            case "englishAddress" :
                column.formGroup = 1;
                column.formOrder = 250;
                column.disabled = true;
                column.hideInForm = false;

            break;
            case "address" :
                column.formGroup = 1;
                column.formOrder = 300;
                column.hideInForm = false;
            break;
            case "englishAddressDetail1" :
                column.formGroup = 1;
                column.formOrder = 350;
                column.hideInForm = false;
            break;
            case "addressDetail" :
                column.formGroup = 1;
                column.formOrder = 390;
                column.hideInForm = false;
            break;
            case "englishAddressDetail2" :
                column.formGroup = 1;
                column.formOrder = 395;
                column.hideInForm = false;
            break;
            case "fax" :
                column.formGroup = 1;
                column.formOrder = 400;
                column.hideInForm = false;
                column.disabled = true;
            break;
            case "countryCode" :
                column.formGroup = 1;
                column.formOrder = 450;
                column.hideInForm = false;
            break;
            case "countryCodeName" :
                column.type = "varchar";
                column.formGroup = 1;
                column.formOrder = 460;
                column.hideInForm = false;
            break;
            case "phoneNumber1" :
                column.formGroup = 1;
                column.formOrder = 500;
                column.hideInForm = false;
            break;
            case "phoneNumber2" :
                column.formGroup = 1;
                column.formOrder = 550;
                column.hideInForm = false;
            break;
          
            case "managementGeneral" :
                column.formGroup = 1;
                column.formOrder = 600;
                column.hideInForm = false;
            break;
            case "session" :
                column.formGroup = 2;
                column.formOrder = 100;
                column.hideInForm = false;
            break;
            case "sessionStartDate" :
                column.formGroup = 2;
                column.formOrder = 200;
                column.formItemType = "date"
                column.hideInForm = false;
            break;
            case "sessionEndDate" :
                column.formGroup = 2;
                column.formOrder = 300;
                column.formItemType = "date"
                column.hideInForm = false;
            break;
            default: 
                column.disabled = true;
                column.required = false;
            break;
        }
    }

}


function CorporationManage ( props ) {

    const { t } = useTranslation();

    const [readOnlyTableSchema, setReadOnlyTableSchema]  = useState();
    const [createTableSchema, setCreateTableSchema]  = useState();
    const [commonTableSchema, setCommonTableSchema] = useState();

    const [grid, setGrid] = useState();

    const [handleSelect, setHandleSelect] = useState();

    const [api, setApi] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const [isEmpty, setIsEmpty] = useState();


    useEffect(() => {

        let mounted = true;

        window.addEventListener('resize', handleResize);
        handleResize();

        (async () => {

            let schema = await getSchema(table);

            let createTableSchema = cloneDeep(schema);
            tableModifySchema(createTableSchema, 'create');
            let commonTableSchema = cloneDeep(schema);
            tableModifySchema(commonTableSchema, 'update');
            let readOnlySchema = cloneDeep(schema);
            readOnlyModifySchema(readOnlySchema);

            if ( mounted ) {
                setReadOnlyTableSchema(readOnlySchema);
                setCreateTableSchema(createTableSchema);
                setCommonTableSchema(commonTableSchema);
            }

        })();

        return ( () => {
            mounted = false;
            window.removeEventListener('resize', handleResize);
        } );


    }, []);

    useEffect(() => {

        if (grid) {

            grid.selectionChanged.addHandler(debounce((grid, event) => {

                if (grid.selectedItems && grid.selectedItems[0]) {

                    setHandleSelect(grid.selectedItems[0])

                } else {

                    setHandleSelect([]);

                };

            }, 10));

            grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                if (grid.selectedItems && grid.selectedItems[0]) {

                    setHandleSelect(grid.selectedItems[0])

                } else {

                    setHandleSelect([]);

                };

            }, 10));
        }

    }, [grid])

    const [height, setHeight] = useState(0);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

   return (
        <div style={{ height: height }} >
            <ReflexContainer orientation="vertical">
            <ReflexElement flex={0.25}>
                <BasicCrudScreenType 
                    id={id}
                    table={table}
                    view={view}
                    headerTitle={t("term.corporation")}
                    onInitialized={(grid)=> setGrid(grid)}
                    onApiInitialized={(api)=> setApi(api)}
                    onLoadData = {(data)=> {
                        setIsEmpty(data.length < 1 ? true : false)
                    }}
                    noCreate
                    noEdit
                    noDelete
                    noExcel
                />
            </ReflexElement>
            <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />
            <ReflexElement flex={0.75}>

            <BasicCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">
                <BasicCrudActionsLayout>
                    <ToolbarFlexSpacer xs />
                    <BasicCrudScreenActionItemLayout>
                        <CorporationManageCreateButton
                            id={id}
                            schema={createTableSchema}
                            refresh={api}
                            onSuccess={onSuccess}
                        />
                    </BasicCrudScreenActionItemLayout>
                    <BasicCrudScreenActionItemLayout>
                        <CorporationManageUpdateButton
                            id={id}
                            schema={commonTableSchema}
                            grid={grid}
                            refresh={api}
                            onSuccess={onSuccess}
                            disabled = {isEmpty}
                        />
                    </BasicCrudScreenActionItemLayout>
                    <BasicCrudScreenActionItemLayout>
                        <CoprationDeleteButton
                            id={id}
                            schema={commonTableSchema}
                            grid={grid}
                            color="secondary"
                            refresh={api}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                            disabled = {isEmpty}
                        />
                    </BasicCrudScreenActionItemLayout>
                </BasicCrudActionsLayout>
            </BasicCrudScreenHeaderLayout>
                    <AutoFormViewLayout>
                        <AutoForm
                            schema = {readOnlyTableSchema}
                            mode = "edit"
                            initialData = {{...handleSelect}}
                            onChange = {()=>{}}
                        />
                    </AutoFormViewLayout>
            </ReflexElement>
            </ReflexContainer>
        </div>
    )
}

export default CorporationManage;

